import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Mobile, MiniMobile, ExtraMiniMobile } from '../../../_Variable/var';

const Wrapper = styled.div`
	&.h1Default {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 2rem;
		line-height: 140%;
		color: #4f4f4f;
		@media only screen and (max-width: ${Mobile}) {
			font-size: 1.375rem;
		}
		@media only screen and (max-width: ${MiniMobile}) {
			font-size: 1.3rem;
		}
		@media only screen and (max-width: ${ExtraMiniMobile}) {
			font-size: 1.2rem;
		}
	}
`;

const H1 = ({ children, className }) => {
	return <Wrapper className={className || 'h1Default'}>{children}</Wrapper>;
};

H1.defaultProps = {
	className: '',
};

H1.propTypes = {
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default H1;
